var AgRuSdkMethods = /* @__PURE__ */ ((AgRuSdkMethods2) => {
  AgRuSdkMethods2["Authorize"] = "agru-authorize";
  AgRuSdkMethods2["AuthorizeAndWait"] = "agru-authorizeAndWait";
  AgRuSdkMethods2["GetSaveData"] = "agru-getSaveData";
  AgRuSdkMethods2["GetUsers"] = "agru-getUsers";
  AgRuSdkMethods2["IsAppUser"] = "agru-isAppUser";
  AgRuSdkMethods2["Logout"] = "agru-logout";
  AgRuSdkMethods2["SayHello"] = "agru-sayHello";
  AgRuSdkMethods2["ShowCampaign"] = "agru-showCampaign";
  AgRuSdkMethods2["ShowPayment"] = "agru-showPayment";
  AgRuSdkMethods2["SetSaveData"] = "agru-setSaveData";
  AgRuSdkMethods2["ToggleFullscreen"] = "agru-toggleFullscreen";
  return AgRuSdkMethods2;
})(AgRuSdkMethods || {});
var AgRuSdkEvents = /* @__PURE__ */ ((AgRuSdkEvents2) => {
  AgRuSdkEvents2["OptionsUpdates"] = "agru-optionsUpdates";
  return AgRuSdkEvents2;
})(AgRuSdkEvents || {});

function mitt(n){return {all:n=n||new Map,on:function(t,e){var i=n.get(t);i?i.push(e):n.set(t,[e]);},off:function(t,e){var i=n.get(t);i&&(e?i.splice(i.indexOf(e)>>>0,1):n.set(t,[]));},emit:function(t,e){var i=n.get(t);i&&i.slice().map(function(n){n(e);}),(i=n.get("*"))&&i.slice().map(function(n){n(t,e);});}}}

class AgRuSdk {
  constructor(options = {}) {
    this.options = options;
    if (AgRuSdk._instance) {
      return AgRuSdk._instance;
    }
    for (const [key, value] of new URLSearchParams(location.search).entries()) {
      this.options[key] = value;
    }
    if (!this.options.auth_key) {
      console.warn('You need to pass the "auth_key" in options, to be able to use the SDK.');
    }
    AgRuSdk._instance = this;
    AgRuSdk._instance._emitter = this._createEmitter();
    AgRuSdk._instance.options = options;
    this._listen();
    return this;
  }
  _createEmitter() {
    const instance = mitt();
    const on = instance.on;
    instance.on = (type, handler) => {
      if (typeof handler === "function") {
        on(type, (args) => handler.call(null, ...args));
      }
    };
    instance.once = (type, handler) => {
      const wrap = (...args) => {
        instance.off(type, wrap);
        if (typeof handler === "function") {
          handler.call(null, ...args);
        }
      };
      on(type, wrap);
    };
    return instance;
  }
  _handleEvent(type, callback) {
    if (callback) {
      return this._emitter.once(type, callback);
    }
    return new Promise((resolve) => this._emitter.once(type, (...args) => resolve(args)));
  }
  _listen() {
    window.addEventListener("message", (event) => {
      const { data, type } = event.data;
      if (event.source === window) {
        return;
      }
      this._emitter.emit(type, data);
    });
  }
  _sendMessage(type, data) {
    return top == null ? void 0 : top.postMessage({ data, type }, "*");
  }
  authorize(callback) {
    this._sendMessage(AgRuSdkMethods.Authorize, void 0);
    return this._handleEvent(AgRuSdkMethods.Authorize, callback);
  }
  authorizeAndWait(callback) {
    this._sendMessage(AgRuSdkMethods.AuthorizeAndWait, void 0);
    return this._handleEvent(AgRuSdkMethods.AuthorizeAndWait, callback);
  }
  getSaveData(callback) {
    this._sendMessage(AgRuSdkMethods.GetSaveData, this.options);
    return this._handleEvent(AgRuSdkMethods.GetSaveData, callback);
  }
  getUsers(ids, callback) {
    this._sendMessage(AgRuSdkMethods.GetUsers, ids.join(","));
    return this._handleEvent(AgRuSdkMethods.GetUsers, callback);
  }
  isAppUser(userId, callback) {
    this._sendMessage(AgRuSdkMethods.IsAppUser, userId);
    return this._handleEvent(AgRuSdkMethods.IsAppUser, callback);
  }
  logout(callback) {
    this._sendMessage(AgRuSdkMethods.Logout, null);
    return this._handleEvent(AgRuSdkMethods.Logout, callback);
  }
  off(type, handler) {
    return this._emitter.off(type, handler);
  }
  on(type, handler) {
    this._emitter.on(type, handler);
    const events = Object.values(AgRuSdkEvents);
    if (events.includes(type)) {
      this._sendMessage("event", type);
    }
    return () => this._emitter.off(type, handler);
  }
  once(type, handler) {
    return this._emitter.once(type, handler);
  }
  sayHello(callback) {
    const message = "And here's Johnny";
    this._sendMessage(AgRuSdkMethods.SayHello, message);
    return this._handleEvent(AgRuSdkMethods.SayHello, callback);
  }
  showCampaign(type = "default", callback) {
    this._sendMessage(AgRuSdkMethods.ShowCampaign, {
      options: this.options,
      type
    });
    return this._handleEvent(AgRuSdkMethods.ShowCampaign, callback);
  }
  showPayment(paymentToken, callback) {
    this._sendMessage(AgRuSdkMethods.ShowPayment, paymentToken);
    return this._handleEvent(AgRuSdkMethods.ShowPayment, callback);
  }
  toggleFullscreen(callback) {
    this._sendMessage(AgRuSdkMethods.ToggleFullscreen, null);
    return this._handleEvent(AgRuSdkMethods.ToggleFullscreen, callback);
  }
  setSaveData(data, callback) {
    this._sendMessage(AgRuSdkMethods.SetSaveData, {
      data,
      options: this.options
    });
    return this._handleEvent(AgRuSdkMethods.SetSaveData, callback);
  }
}

export { AgRuSdk, AgRuSdkEvents, AgRuSdkMethods };
